<template>
    <div :id="component_data.id" class="feat_wrapper font-responsive">
        <div class="feat_contents w-5/6 mobile:w-full mobile:flex-column mx-auto">
            <div class="feat_visual w-1/2 mobile:w-full active_tabpanel">
                <div class="feat_photo-big">
                    <mid class="tab_photo-big--inner" v-if="component_data.params.slides" :component_data="{component:'slides', options:component_data.params.slides_options, images:component_data.params.slides, static_bg: component_data.params.img.src}"></mid>
                    <img class="tab_photo-big--inner" v-else :src="component_data.params.img.src" :alt="component_data.params.img.alt">

                    <video-block class="feat_video feat_video_r" v-if="component_data.params.vid" :component_data="component_data.params.vid"> </video-block>
                    <!-- <a v-if="component_data.params.vid" class="feat_video feat_video_l" :href="component_data.params.vid.url"><img :src="component_data.params.vid.thumb.src" :alt="component_data.params.vid.thumb.alt"></a> -->

                    <p v-html="component_data.params.photo_note"></p>
                </div>
            </div>
            <article class="feat_caption w-2/5 mobile:w-full mobile-sides">
                <header>
                    <figure class="feat_icon" v-html="component_data.params.icon"></figure>
                    <h2 v-html="component_data.params.title"></h2>
                </header>
                <div class="feat_texts">
                    <p v-for="(text, index) in texts(component_data.params)" v-html="text" :key="index"></p>
                </div>
            </article>

        </div>
    </div>
</template>

<script>
import video from '@/components/videoBlock/video'

export default {
    props: ['component_data'],
    data(){
        return {
            
        }
    },
    mounted(){
        this.$nextTick(()=>{

        })
    },
    components: {
        "video-block": video
    }
}
</script>

<style>
    /* Base elements */

        .feat_wrapper {
            position: relative;
            margin: 6em 0;
        }

        .feat_wrapper::before {
            content: '';
            height: 100%;
            width: 91.6666%;
            position: absolute;
            background-color: #FAF9F7;        
        }
        .tabpanel_inner {
            width: 100vw;
            max-width: 1920px;
        }
        .feat_contents {
            position: relative;
            margin: 0 auto;
            display: flex;
        }
        .feat_visual {
            position: relative;
            z-index: 0;
            margin: 4em 0;
        }
        .feat_photo-small,
        .feat_video {
            bottom: -6em;
            display: flex;
            z-index: 1;
        }

        .feat_photo-big {
            height: 36.55vw;
            width: 33.33vw;   
            position: relative;        
        }
        .feat_photo-big::before
        {
            position: absolute;
            height: 15.49vw;
            width: 25vw;        
            bottom: -3em;
            z-index: -1;
        }
        .feat_video img,
        .feat_photo-big>img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
        .feat_caption {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 3em 0;
        }
        .feat_caption header {
            display: flex;
            align-items: center;
            margin-bottom: 4.5em;
        }
        .feat_caption header h2 {
            color: #E41429;
            line-height: 1.41em;
            font-size: 3.8em;
            font-weight: 700;
            margin: 0 0 0 1.25em;
            padding-right: 0.625em;
            font-family: 'Uni Neue', sans-serif;
        }
        .feat_texts {
            padding: 0 3em;
        }
        .feat_caption p {
            font-size: 2em;
            line-height: 1.9em;
            font-family: 'Lato', sans-serif;
        }
        .feat_icon {
            margin: 0;
        }
        .feat_icon svg {
            width: 10em;
            height: 10em;
            border-radius: 8px;
            color: white;
            background-color: #E41429;
            margin: 0;
        }
        .feat_wrapper img {
            max-width: 100%;
        }
        .feat_video.feat_video_r .avc_thumb{
            border-top-left-radius: 3em; 
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
        }
</style>

<style scoped>
    .feat_contents {
        flex-direction: row-reverse;
    }
    .feat_photo-big {
        margin-left: auto;
    }
    .feat_photo-big .tab_photo-big--inner {
        border-top-right-radius: 6em;
        overflow: hidden;
    }
    .feat_video {
        content: '';
        position: absolute;
        height: 15.49vw;
        width: 25vw;        
        left: -3em;
        bottom: -6em;  
        z-index: 1;     
    }
    .feat_video img {
        border-top-left-radius: 3em; 
    }
    .feat_photo-big::before {
        content: '';
        position: absolute;
        height: 15.49vw;
        width: 25vw;
        z-index: -1;  
        bottom: 0;
        transform: translateX(-6em) translateY(3em);

        border-bottom-left-radius: 3em;
        background: linear-gradient(to right, #AE0B11, #E41429);
    }
    @media (min-width: 1920px){
        .feat_photo-big {
            width: 620px;
            height: 680px;
        }
        .feat_video,
        .feat_photo-big::before {
            width: 460px;
            height: 285px;            
        }       
    }
    .feat_wrapper::before { 
        border-top-left-radius: 6em;
        right: 0;
    }

</style>

<style>
    @media(max-width: 992px){
        .feat_visual {
            align-items: center;
        }
    }
</style>